export const SAVE_DAMAGE_DEFINITIONS = Object.freeze({
  'spell:vicious-mockery': Object.freeze({
    id: 'spell:vicious-mockery', name: 'Vicious Mockery', rulesVersion: '2024', level: 0, school: 'enchantment',
    delivery: 'saving-throw', targeting: Object.freeze({ shape: 'single', rangeFeet: 60, validateRange: true, perception: 'see-or-hear', automated: false }),
    save: Object.freeze({ ability: 'wisdom', successDamageRule: 'none', failureDamageRule: 'full' }),
    damage: Object.freeze({ components: Object.freeze([Object.freeze({ formula: '1d6', type: 'psychic' })]) }),
    scaling: Object.freeze({ mode: 'character-level' }), rider: Object.freeze({ kind: 'next-attack-disadvantage', on: 'failed-save' }),
    actionCost: Object.freeze({ resource: 'action' }), resource: Object.freeze({ type: 'none' }),
  }),
  'spell:sacred-flame': Object.freeze({
    id: 'spell:sacred-flame', name: 'Sacred Flame', rulesVersion: '2024', level: 0, school: 'evocation',
    delivery: 'saving-throw', targeting: Object.freeze({ shape: 'single', rangeFeet: 60, automated: false }),
    save: Object.freeze({ ability: 'dexterity', successDamageRule: 'none', failureDamageRule: 'full', ignoresCover: true }),
    damage: Object.freeze({ components: Object.freeze([Object.freeze({ formula: '1d8', type: 'radiant' })]) }),
    scaling: Object.freeze({ mode: 'character-level' }),
    actionCost: Object.freeze({ resource: 'action' }), resource: Object.freeze({ type: 'none' }),
  }),
  'spell:acid-splash': Object.freeze({
    id: 'spell:acid-splash', name: 'Acid Splash', rulesVersion: '2024', level: 0,
    delivery: 'saving-throw', targeting: Object.freeze({ shape: 'sphere', radiusFeet: 5, rangeFeet: 60, requiresPlacement: true, automated: false }),
    save: Object.freeze({ ability: 'dexterity', successDamageRule: 'none', failureDamageRule: 'full' }),
    damage: Object.freeze({ components: Object.freeze([Object.freeze({ formula: '1d6', type: 'acid' })]) }),
    scaling: Object.freeze({ mode: 'character-level' }), actionCost: Object.freeze({ resource: 'action' }), resource: Object.freeze({ type: 'none' }),
  }),
  'spell:thunderwave': Object.freeze({
    id: 'spell:thunderwave', name: 'Thunderwave', rulesVersion: '2024', level: 1,
    delivery: 'saving-throw', targeting: Object.freeze({ shape: 'cube', sizeFeet: 15, origin: 'self', requiresPlacement: true, automated: false }),
    save: Object.freeze({ ability: 'constitution', successDamageRule: 'half', failureDamageRule: 'full' }),
    damage: Object.freeze({ components: Object.freeze([Object.freeze({ formula: '2d8', type: 'thunder' })]) }),
    scaling: Object.freeze({ mode: 'dice-per-slot-level', component: 0, dicePerLevel: 1 }),
    movement: Object.freeze({ on: 'failed-save', kind: 'push', distanceFeet: 10 }),
    actionCost: Object.freeze({ resource: 'action' }), resource: Object.freeze({ type: 'spellSlot' }),
  }),
  'spell:burning-hands': Object.freeze({
    id: 'spell:burning-hands', name: 'Burning Hands', rulesVersion: '2024', level: 1,
    school: 'evocation', delivery: 'saving-throw', targeting: Object.freeze({ shape: 'cone', sizeFeet: 15, automated: false }),
    save: Object.freeze({ ability: 'dexterity', successDamageRule: 'half', failureDamageRule: 'full' }),
    damage: Object.freeze({ components: Object.freeze([Object.freeze({ formula: '3d6', type: 'fire' })]) }),
    scaling: Object.freeze({ mode: 'dice-per-slot-level', component: 0, dicePerLevel: 1 }),
    actionCost: Object.freeze({ resource: 'action' }),
    resource: Object.freeze({ type: 'spellSlot' }),
  }),
  'spell:inflict-wounds': Object.freeze({
    id: 'spell:inflict-wounds', name: 'Inflict Wounds', rulesVersion: '2024', level: 1,
    school: 'necromancy', delivery: 'saving-throw', targeting: Object.freeze({ shape: 'single', range: 'touch', automated: false }),
    save: Object.freeze({ ability: 'constitution', successDamageRule: 'half', failureDamageRule: 'full' }),
    damage: Object.freeze({ components: Object.freeze([Object.freeze({ formula: '2d10', type: 'necrotic' })]) }),
    scaling: Object.freeze({ mode: 'dice-per-slot-level', component: 0, dicePerLevel: 1 }),
    actionCost: Object.freeze({ resource: 'action' }), resource: Object.freeze({ type: 'spellSlot' }),
  }),
  'spell:lightning-bolt': Object.freeze({
    id: 'spell:lightning-bolt', name: 'Lightning Bolt', rulesVersion: '2024', level: 3,
    school: 'evocation', delivery: 'saving-throw', targeting: Object.freeze({ shape: 'line', lengthFeet: 100, widthFeet: 5, automated: false }),
    save: Object.freeze({ ability: 'dexterity', successDamageRule: 'half', failureDamageRule: 'full' }),
    damage: Object.freeze({ components: Object.freeze([Object.freeze({ formula: '8d6', type: 'lightning' })]) }),
    scaling: Object.freeze({ mode: 'dice-per-slot-level', component: 0, dicePerLevel: 1 }),
    actionCost: Object.freeze({ resource: 'action' }), resource: Object.freeze({ type: 'spellSlot' }),
  }),
  'spell:fireball': Object.freeze({
    id: 'spell:fireball', name: 'Fireball', rulesVersion: '2024', level: 3,
    school: 'evocation', delivery: 'saving-throw', targeting: Object.freeze({ shape: 'sphere', radiusFeet: 20, rangeFeet: 150, automated: false }),
    save: Object.freeze({ ability: 'dexterity', successDamageRule: 'half', failureDamageRule: 'full' }),
    damage: Object.freeze({ components: Object.freeze([Object.freeze({ formula: '8d6', type: 'fire' })]) }),
    scaling: Object.freeze({ mode: 'dice-per-slot-level', component: 0, dicePerLevel: 1 }),
    actionCost: Object.freeze({ resource: 'action' }), resource: Object.freeze({ type: 'spellSlot' }),
  }),
  'spell:circle-of-death': Object.freeze({
    id: 'spell:circle-of-death', name: 'Circle of Death', rulesVersion: '2024', level: 6,
    school: 'necromancy', delivery: 'saving-throw', targeting: Object.freeze({ shape: 'sphere', radiusFeet: 60, rangeFeet: 150, automated: false }),
    save: Object.freeze({ ability: 'constitution', successDamageRule: 'half', failureDamageRule: 'full' }),
    damage: Object.freeze({ components: Object.freeze([Object.freeze({ formula: '8d8', type: 'necrotic' })]) }),
    scaling: Object.freeze({ mode: 'dice-per-slot-level', component: 0, dicePerLevel: 2 }),
    actionCost: Object.freeze({ resource: 'action' }), resource: Object.freeze({ type: 'spellSlot' }),
  }),
  'spell:shatter': Object.freeze({
    id: 'spell:shatter', name: 'Shatter', rulesVersion: '2024', level: 2, school: 'evocation',
    delivery: 'saving-throw', targeting: Object.freeze({ shape: 'sphere', radiusFeet: 10, rangeFeet: 60, automated: false }),
    save: Object.freeze({ ability: 'constitution', successDamageRule: 'half', failureDamageRule: 'full', disadvantageCreatureTypes: Object.freeze(['construct']) }),
    damage: Object.freeze({ components: Object.freeze([Object.freeze({ formula: '3d8', type: 'thunder' })]) }),
    scaling: Object.freeze({ mode: 'dice-per-slot-level', component: 0, dicePerLevel: 1 }),
    actionCost: Object.freeze({ resource: 'action' }), resource: Object.freeze({ type: 'spellSlot' }),
  }),
  'spell:cone-of-cold': Object.freeze({
    id: 'spell:cone-of-cold', name: 'Cone of Cold', rulesVersion: '2024', level: 5, school: 'evocation',
    delivery: 'saving-throw', targeting: Object.freeze({ shape: 'cone', sizeFeet: 60, automated: false }),
    save: Object.freeze({ ability: 'constitution', successDamageRule: 'half', failureDamageRule: 'full' }),
    damage: Object.freeze({ components: Object.freeze([Object.freeze({ formula: '8d8', type: 'cold' })]) }),
    scaling: Object.freeze({ mode: 'dice-per-slot-level', component: 0, dicePerLevel: 1 }),
    actionCost: Object.freeze({ resource: 'action' }), resource: Object.freeze({ type: 'spellSlot' }),
  }),
  'spell:flame-strike': Object.freeze({
    id: 'spell:flame-strike', name: 'Flame Strike', rulesVersion: '2024', level: 5, school: 'evocation',
    delivery: 'saving-throw', targeting: Object.freeze({ shape: 'cylinder', radiusFeet: 10, heightFeet: 40, rangeFeet: 60, automated: false }),
    save: Object.freeze({ ability: 'dexterity', successDamageRule: 'half', failureDamageRule: 'full' }),
    damage: Object.freeze({ components: Object.freeze([Object.freeze({ formula: '5d6', type: 'fire' }), Object.freeze({ formula: '5d6', type: 'radiant' })]) }),
    scaling: Object.freeze({ mode: 'dice-per-slot-level', components: Object.freeze([0, 1]), dicePerLevel: 1 }),
    actionCost: Object.freeze({ resource: 'action' }), resource: Object.freeze({ type: 'spellSlot' }),
  }),
  'spell:fire-storm': Object.freeze({
    id: 'spell:fire-storm', name: 'Fire Storm', rulesVersion: '2024', level: 7, school: 'evocation',
    delivery: 'saving-throw', targeting: Object.freeze({ shape: 'cube', sizeFeet: 10, rangeFeet: 150, minAreas: 2, maxAreas: 10, requiresNeighbor: true, automated: false }),
    save: Object.freeze({ ability: 'dexterity', successDamageRule: 'half', failureDamageRule: 'full' }),
    damage: Object.freeze({ components: Object.freeze([Object.freeze({ formula: '7d10', type: 'fire' })]) }),
    actionCost: Object.freeze({ resource: 'action' }), resource: Object.freeze({ type: 'spellSlot' }),
  }),
  'spell:meteor-swarm': Object.freeze({
    id: 'spell:meteor-swarm', name: 'Meteor Swarm', rulesVersion: '2024', level: 9, school: 'evocation',
    delivery: 'saving-throw', targeting: Object.freeze({ shape: 'sphere', radiusFeet: 40, rangeFeet: 5280, minAreas: 4, maxAreas: 4, automated: false }),
    save: Object.freeze({ ability: 'dexterity', successDamageRule: 'half', failureDamageRule: 'full' }),
    damage: Object.freeze({ components: Object.freeze([Object.freeze({ formula: '20d6', type: 'fire' }), Object.freeze({ formula: '20d6', type: 'bludgeoning' })]) }),
    actionCost: Object.freeze({ resource: 'action' }), resource: Object.freeze({ type: 'spellSlot' }),
  }),
  // The side effects these leave to the table reach the DM as notes (spellTableNotes.mjs).
  'spell:dissonant-whispers': Object.freeze({
    id: 'spell:dissonant-whispers', name: 'Dissonant Whispers', rulesVersion: '2024', level: 1, school: 'enchantment',
    delivery: 'saving-throw', targeting: Object.freeze({ shape: 'single', rangeFeet: 60, automated: false }),
    save: Object.freeze({ ability: 'wisdom', successDamageRule: 'half', failureDamageRule: 'full' }),
    damage: Object.freeze({ components: Object.freeze([Object.freeze({ formula: '3d6', type: 'psychic' })]) }),
    scaling: Object.freeze({ mode: 'dice-per-slot-level', component: 0, dicePerLevel: 1 }),
    actionCost: Object.freeze({ resource: 'action' }), resource: Object.freeze({ type: 'spellSlot' }),
  }),
  'spell:blight': Object.freeze({
    id: 'spell:blight', name: 'Blight', rulesVersion: '2024', level: 4, school: 'necromancy',
    delivery: 'saving-throw', targeting: Object.freeze({ shape: 'single', rangeFeet: 30, automated: false }),
    save: Object.freeze({ ability: 'constitution', successDamageRule: 'half', failureDamageRule: 'full' }),
    damage: Object.freeze({ components: Object.freeze([Object.freeze({ formula: '8d8', type: 'necrotic' })]) }),
    scaling: Object.freeze({ mode: 'dice-per-slot-level', component: 0, dicePerLevel: 1 }),
    actionCost: Object.freeze({ resource: 'action' }), resource: Object.freeze({ type: 'spellSlot' }),
  }),
  'spell:ice-storm': Object.freeze({
    id: 'spell:ice-storm', name: 'Ice Storm', rulesVersion: '2024', level: 4, school: 'evocation',
    delivery: 'saving-throw', targeting: Object.freeze({ shape: 'cylinder', radiusFeet: 20, heightFeet: 40, rangeFeet: 300, automated: false }),
    save: Object.freeze({ ability: 'dexterity', successDamageRule: 'half', failureDamageRule: 'full' }),
    damage: Object.freeze({ components: Object.freeze([Object.freeze({ formula: '2d10', type: 'bludgeoning' }), Object.freeze({ formula: '4d6', type: 'cold' })]) }),
    leavesDifficultTerrain: true,
    scaling: Object.freeze({ mode: 'dice-per-slot-level', component: 0, dicePerLevel: 1 }),
    actionCost: Object.freeze({ resource: 'action' }), resource: Object.freeze({ type: 'spellSlot' }),
  }),
  'spell:disintegrate': Object.freeze({
    id: 'spell:disintegrate', name: 'Disintegrate', rulesVersion: '2024', level: 6, school: 'transmutation',
    delivery: 'saving-throw', targeting: Object.freeze({ shape: 'single', rangeFeet: 60, automated: false }),
    save: Object.freeze({ ability: 'dexterity', successDamageRule: 'none', failureDamageRule: 'full' }),
    damage: Object.freeze({ components: Object.freeze([Object.freeze({ formula: '10d6', type: 'force', flatBonus: 40 })]) }),
    scaling: Object.freeze({ mode: 'dice-per-slot-level', component: 0, dicePerLevel: 3 }),
    actionCost: Object.freeze({ resource: 'action' }), resource: Object.freeze({ type: 'spellSlot' }),
  }),
  'spell:freezing-sphere': Object.freeze({
    id: 'spell:freezing-sphere', name: 'Freezing Sphere', rulesVersion: '2024', level: 6, school: 'evocation',
    delivery: 'saving-throw', targeting: Object.freeze({ shape: 'sphere', radiusFeet: 60, rangeFeet: 300, requiresPlacement: true, automated: false }),
    save: Object.freeze({ ability: 'constitution', successDamageRule: 'half', failureDamageRule: 'full' }),
    damage: Object.freeze({ components: Object.freeze([Object.freeze({ formula: '10d6', type: 'cold' })]) }),
    scaling: Object.freeze({ mode: 'dice-per-slot-level', component: 0, dicePerLevel: 1 }),
    actionCost: Object.freeze({ resource: 'action' }), resource: Object.freeze({ type: 'spellSlot' }),
  }),
  'spell:sunburst': Object.freeze({
    id: 'spell:sunburst', name: 'Sunburst', rulesVersion: '2024', level: 8, school: 'evocation',
    delivery: 'saving-throw', targeting: Object.freeze({ shape: 'sphere', radiusFeet: 60, rangeFeet: 150, requiresPlacement: true, automated: false }),
    save: Object.freeze({ ability: 'constitution', successDamageRule: 'half', failureDamageRule: 'full' }),
    damage: Object.freeze({ components: Object.freeze([Object.freeze({ formula: '12d6', type: 'radiant' })]) }),
    rider: Object.freeze({ kind: 'condition', on: 'failed-save', condition: 'blinded', name: 'Blinded', icon: '\u{1F648}', rounds: 10, repeatAbility: 'constitution' }),
    actionCost: Object.freeze({ resource: 'action' }), resource: Object.freeze({ type: 'spellSlot' }),
  }),
  // The side effects these leave to the table reach the DM as notes (spellTableNotes.mjs).
  'spell:mind-spike': Object.freeze({
    id: 'spell:mind-spike', name: 'Mind Spike', rulesVersion: '2024', level: 2, school: 'divination', concentrationRounds: 600,
    delivery: 'saving-throw', targeting: Object.freeze({ shape: 'single', rangeFeet: 120, automated: false }),
    save: Object.freeze({ ability: 'wisdom', successDamageRule: 'half', failureDamageRule: 'full' }),
    damage: Object.freeze({ components: Object.freeze([Object.freeze({ formula: '3d8', type: 'psychic' })]) }),
    scaling: Object.freeze({ mode: 'dice-per-slot-level', component: 0, dicePerLevel: 1 }),
    actionCost: Object.freeze({ resource: 'action' }), resource: Object.freeze({ type: 'spellSlot' }),
  }),
  'spell:finger-of-death': Object.freeze({
    id: 'spell:finger-of-death', name: 'Finger of Death', rulesVersion: '2024', level: 7, school: 'necromancy',
    delivery: 'saving-throw', targeting: Object.freeze({ shape: 'single', rangeFeet: 60, automated: false }),
    save: Object.freeze({ ability: 'constitution', successDamageRule: 'half', failureDamageRule: 'full' }),
    damage: Object.freeze({ components: Object.freeze([Object.freeze({ formula: '7d8', type: 'necrotic', flatBonus: 30 })]) }),
    actionCost: Object.freeze({ resource: 'action' }), resource: Object.freeze({ type: 'spellSlot' }),
  }),
  'spell:harm': Object.freeze({
    id: 'spell:harm', name: 'Harm', rulesVersion: '2024', level: 6, school: 'necromancy',
    delivery: 'saving-throw', targeting: Object.freeze({ shape: 'single', rangeFeet: 60, automated: false }),
    save: Object.freeze({ ability: 'constitution', successDamageRule: 'half', failureDamageRule: 'full' }),
    damage: Object.freeze({ components: Object.freeze([Object.freeze({ formula: '14d6', type: 'necrotic' })]) }),
    actionCost: Object.freeze({ resource: 'action' }), resource: Object.freeze({ type: 'spellSlot' }),
  }),
  'spell:vitriolic-sphere': Object.freeze({
    id: 'spell:vitriolic-sphere', name: 'Vitriolic Sphere', rulesVersion: '2024', level: 4, school: 'evocation',
    delivery: 'saving-throw', targeting: Object.freeze({ shape: 'sphere', radiusFeet: 20, rangeFeet: 150, requiresPlacement: true, automated: false }),
    save: Object.freeze({ ability: 'dexterity', successDamageRule: 'half', failureDamageRule: 'full' }),
    damage: Object.freeze({ components: Object.freeze([Object.freeze({ formula: '10d4', type: 'acid' })]) }),
    scaling: Object.freeze({ mode: 'dice-per-slot-level', component: 0, dicePerLevel: 2 }),
    rider: Object.freeze({ kind: 'delayed-damage', on: 'failed-save', count: 5, sides: 4, type: 'acid' }),
    actionCost: Object.freeze({ resource: 'action' }), resource: Object.freeze({ type: 'spellSlot' }),
  }),
  'spell:sunbeam': Object.freeze({
    id: 'spell:sunbeam', name: 'Sunbeam', rulesVersion: '2024', level: 6, school: 'evocation', concentrationRounds: 10, repeatsWhileConcentrating: true,
    delivery: 'saving-throw', targeting: Object.freeze({ shape: 'line', lengthFeet: 60, widthFeet: 5, automated: false }),
    save: Object.freeze({ ability: 'constitution', successDamageRule: 'half', failureDamageRule: 'full' }),
    damage: Object.freeze({ components: Object.freeze([Object.freeze({ formula: '6d8', type: 'radiant' })]) }),
    rider: Object.freeze({ kind: 'condition', on: 'failed-save', condition: 'blinded', name: 'Blinded', icon: '\u{1F648}', untilCasterTurnStarts: true }),
    actionCost: Object.freeze({ resource: 'action' }), resource: Object.freeze({ type: 'spellSlot' }),
  }),
  'spell:weird': Object.freeze({
    id: 'spell:weird', name: 'Weird', rulesVersion: '2024', level: 9, school: 'illusion', concentrationRounds: 10,
    delivery: 'saving-throw', targeting: Object.freeze({ shape: 'sphere', radiusFeet: 30, rangeFeet: 120, requiresPlacement: true, automated: false }),
    save: Object.freeze({ ability: 'wisdom', successDamageRule: 'half', failureDamageRule: 'full' }),
    damage: Object.freeze({ components: Object.freeze([Object.freeze({ formula: '10d10', type: 'psychic' })]) }),
    rider: Object.freeze({ kind: 'condition', on: 'failed-save', condition: 'frightened', name: 'Frightened', icon: '\u{1F631}', rounds: 10, repeatAbility: 'wisdom', failureDamage: Object.freeze({ count: 5, sides: 10, type: 'psychic' }), endsWithConcentration: true }),
    actionCost: Object.freeze({ resource: 'action' }), resource: Object.freeze({ type: 'spellSlot' }),
  }),
  // One target, then up to three more within 30 feet of it, chosen by the caster.
  'spell:chain-lightning': Object.freeze({
    id: 'spell:chain-lightning', name: 'Chain Lightning', rulesVersion: '2024', level: 6, school: 'evocation',
    delivery: 'saving-throw', targeting: Object.freeze({ shape: 'single', rangeFeet: 150, chainFeet: 30, chainTargets: 3, automated: false }),
    save: Object.freeze({ ability: 'dexterity', successDamageRule: 'half', failureDamageRule: 'full' }),
    damage: Object.freeze({ components: Object.freeze([Object.freeze({ formula: '10d8', type: 'lightning' })]) }),
    actionCost: Object.freeze({ resource: 'action' }), resource: Object.freeze({ type: 'spellSlot' }),
  }),
  'spell:phantasmal-killer': Object.freeze({
    id: 'spell:phantasmal-killer', name: 'Phantasmal Killer', rulesVersion: '2024', level: 4, school: 'illusion', concentrationRounds: 10,
    delivery: 'saving-throw', targeting: Object.freeze({ shape: 'single', rangeFeet: 120, automated: false }),
    save: Object.freeze({ ability: 'wisdom', successDamageRule: 'half', failureDamageRule: 'full' }),
    damage: Object.freeze({ components: Object.freeze([Object.freeze({ formula: '4d10', type: 'psychic' })]) }),
    scaling: Object.freeze({ mode: 'dice-per-slot-level', component: 0, dicePerLevel: 1 }),
    rider: Object.freeze({ kind: 'lasting-terror', on: 'failed-save', repeatAbility: 'wisdom' }),
    actionCost: Object.freeze({ resource: 'action' }), resource: Object.freeze({ type: 'spellSlot' }),
  }),
  'spell:contagion': Object.freeze({
    id: 'spell:contagion', name: 'Contagion', rulesVersion: '2024', level: 5, school: 'necromancy',
    delivery: 'saving-throw', targeting: Object.freeze({ shape: 'single', rangeFeet: 5, automated: false }),
    save: Object.freeze({ ability: 'constitution', successDamageRule: 'none', failureDamageRule: 'full' }),
    damage: Object.freeze({ components: Object.freeze([Object.freeze({ formula: '11d8', type: 'necrotic' })]) }),
    rider: Object.freeze({ kind: 'condition', on: 'failed-save', condition: 'poisoned', name: 'Poisoned', icon: '\u2620', rounds: 100800, repeatAbility: 'constitution', tally: Object.freeze({ successesNeeded: 3, failuresNeeded: 3 }) }),
    actionCost: Object.freeze({ resource: 'action' }), resource: Object.freeze({ type: 'spellSlot' }),
  }),
  // Ice Knife's burst, after its attack, hit or miss. It costs nothing further.
  'spell:ice-knife': Object.freeze({
    id: 'spell:ice-knife', name: 'Ice Knife', rulesVersion: '2024', level: 1, school: 'conjuration', followsAttack: true,
    delivery: 'saving-throw', targeting: Object.freeze({ shape: 'sphere', radiusFeet: 5, rangeFeet: 60, requiresPlacement: true, automated: false }),
    save: Object.freeze({ ability: 'dexterity', successDamageRule: 'none', failureDamageRule: 'full' }),
    damage: Object.freeze({ components: Object.freeze([Object.freeze({ formula: '2d6', type: 'cold' })]) }),
    scaling: Object.freeze({ mode: 'dice-per-slot-level', component: 0, dicePerLevel: 1 }),
    actionCost: Object.freeze({ resource: 'free' }), resource: Object.freeze({ type: 'spellSlot' }),
  }),
  // The bead's explosion. The cast itself is a buff, which keeps the point and counts the dice.
  'spell:delayed-blast-fireball': Object.freeze({
    id: 'spell:delayed-blast-fireball', name: 'Delayed Blast Fireball', rulesVersion: '2024', level: 7, school: 'evocation', followsBead: true,
    delivery: 'saving-throw', targeting: Object.freeze({ shape: 'sphere', radiusFeet: 20, rangeFeet: 150, requiresPlacement: true, automated: false }),
    save: Object.freeze({ ability: 'dexterity', successDamageRule: 'half', failureDamageRule: 'full' }),
    damage: Object.freeze({ components: Object.freeze([Object.freeze({ formula: '12d6', type: 'fire' })]) }),
    actionCost: Object.freeze({ resource: 'free' }), resource: Object.freeze({ type: 'spellSlot' }),
  }),
  // A creature that holds a Dragon's Breath from someone else's casting exhales this. The buff carries the type, dice and DC.
  'spell:dragon-s-breath': Object.freeze({
    id: 'spell:dragon-s-breath', name: 'Dragon’s Breath', rulesVersion: '2024', level: 2, school: 'transmutation', grantedBuff: true,
    delivery: 'saving-throw', targeting: Object.freeze({ shape: 'cone', sizeFeet: 15, requiresPlacement: true, automated: false }),
    save: Object.freeze({ ability: 'dexterity', successDamageRule: 'half', failureDamageRule: 'full' }),
    damage: Object.freeze({ components: Object.freeze([Object.freeze({ formula: '3d6', type: 'fire' })]) }),
    actionCost: Object.freeze({ resource: 'action' }), resource: Object.freeze({ type: 'spellSlot' }),
  }),
  // Each creature's ray is settled from its resolution id: see prismaticRays.
  'spell:prismatic-spray': Object.freeze({
    id: 'spell:prismatic-spray', name: 'Prismatic Spray', rulesVersion: '2024', level: 7, school: 'evocation', rays: true,
    delivery: 'saving-throw', targeting: Object.freeze({ shape: 'cone', sizeFeet: 60, requiresPlacement: true, automated: false }),
    save: Object.freeze({ ability: 'dexterity', successDamageRule: 'half', failureDamageRule: 'full' }),
    damage: Object.freeze({ components: Object.freeze([Object.freeze({ formula: '12d6', type: 'radiant' })]) }),
    rider: Object.freeze({ kind: 'prismatic', on: 'failed-save' }),
    actionCost: Object.freeze({ resource: 'action' }), resource: Object.freeze({ type: 'spellSlot' }),
  }),
  'spell:befuddlement': Object.freeze({
    id: 'spell:befuddlement', name: 'Befuddlement', rulesVersion: '2024', level: 8, school: 'enchantment',
    delivery: 'saving-throw', targeting: Object.freeze({ shape: 'single', rangeFeet: 150, automated: false }),
    save: Object.freeze({ ability: 'intelligence', successDamageRule: 'half', failureDamageRule: 'full' }),
    damage: Object.freeze({ components: Object.freeze([Object.freeze({ formula: '10d12', type: 'psychic' })]) }),
    actionCost: Object.freeze({ resource: 'action' }), resource: Object.freeze({ type: 'spellSlot' }),
  }),
});

export const getSaveDamageDefinition = (id) => Object.prototype.hasOwnProperty.call(SAVE_DAMAGE_DEFINITIONS, id) ? SAVE_DAMAGE_DEFINITIONS[id] : null;

// Catalogue identity is provenance, not permission to execute arbitrary prose.
export const SAVE_DAMAGE_SPELL_BINDINGS = Object.freeze({
  'vicious-mockery': 'spell:vicious-mockery',
  'sacred-flame': 'spell:sacred-flame',
  'acid-splash': 'spell:acid-splash',
  'thunderwave': 'spell:thunderwave',
  'burning-hands': 'spell:burning-hands',
  'inflict-wounds': 'spell:inflict-wounds',
  'lightning-bolt': 'spell:lightning-bolt',
  fireball: 'spell:fireball',
  'circle-of-death': 'spell:circle-of-death',
  'shatter': 'spell:shatter',
  'cone-of-cold': 'spell:cone-of-cold',
  'flame-strike': 'spell:flame-strike',
  'fire-storm': 'spell:fire-storm',
  'meteor-swarm': 'spell:meteor-swarm',
  'dissonant-whispers': 'spell:dissonant-whispers',
  blight: 'spell:blight',
  'ice-storm': 'spell:ice-storm',
  disintegrate: 'spell:disintegrate',
  'freezing-sphere': 'spell:freezing-sphere',
  sunburst: 'spell:sunburst',
  'mind-spike': 'spell:mind-spike',
  sunbeam: 'spell:sunbeam',
  weird: 'spell:weird',
  'chain-lightning': 'spell:chain-lightning',
  'phantasmal-killer': 'spell:phantasmal-killer',
  contagion: 'spell:contagion',
  'ice-knife': 'spell:ice-knife',
  'delayed-blast-fireball': 'spell:delayed-blast-fireball',
  'dragon-s-breath': 'spell:dragon-s-breath',
  'prismatic-spray': 'spell:prismatic-spray',
  'finger-of-death': 'spell:finger-of-death',
  harm: 'spell:harm',
  'vitriolic-sphere': 'spell:vitriolic-sphere',
  befuddlement: 'spell:befuddlement',
});

export const getExecutableSaveDamageDefinitionForSpell = (spellId, {
  definitions = SAVE_DAMAGE_DEFINITIONS, bindings = SAVE_DAMAGE_SPELL_BINDINGS,
} = {}) => {
  const id = Object.prototype.hasOwnProperty.call(bindings, spellId) ? bindings[spellId] : null;
  const definition = id && Object.prototype.hasOwnProperty.call(definitions, id) ? definitions[id] : null;
  return definition?.id === id ? definition : null;
};

export const parseSaveDamageDice = (formula) => {
  const match = /^(\d+)d(4|6|8|10|12)$/.exec(formula || '');
  if (!match || Number(match[1]) < 1 || !Number.isSafeInteger(Number(match[1]))) return null;
  return { count: Number(match[1]), sides: Number(match[2]) };
};

export const supportsSaveDamageActivation = (definition) => {
  const targeting = definition?.targeting;
  const positive = (value) => Number.isFinite(value) && value > 0;
  const supportedShapes = {
    single: true,
    cone: positive(targeting?.sizeFeet),
    line: positive(targeting?.lengthFeet) && positive(targeting?.widthFeet),
    sphere: positive(targeting?.radiusFeet),
    cube: positive(targeting?.sizeFeet),
    cylinder: positive(targeting?.radiusFeet) && positive(targeting?.heightFeet),
  };
  const targetingSupported = targeting?.automated === false
    && Object.prototype.hasOwnProperty.call(supportedShapes, targeting?.shape) && supportedShapes[targeting.shape];
  const scaling = definition?.scaling;
  return Boolean(definition?.delivery === 'saving-throw'
    && Number.isInteger(definition.level) && definition.level >= 0 && definition.level <= 9
    && ['action', 'free'].includes(definition.actionCost?.resource) && (definition.level === 0 ? definition.resource?.type === 'none' : definition.resource?.type === 'spellSlot')
    && ['strength', 'dexterity', 'constitution', 'intelligence', 'wisdom', 'charisma'].includes(definition.save?.ability)
    && ['half', 'none', 'full'].includes(definition.save?.successDamageRule)
    && ['half', 'none', 'full'].includes(definition.save?.failureDamageRule)
    && targetingSupported && definition.damage?.components?.length
    && definition.damage.components.every((component) => parseSaveDamageDice(component.formula) && typeof component.type === 'string' && component.type.trim())
    && (!scaling || (definition.level === 0 && scaling.mode === 'character-level') || (scaling.mode === 'dice-per-slot-level' && (scaling.components || [scaling.component]).length > 0
      && (scaling.components || [scaling.component]).every((index) => Number.isInteger(index) && index >= 0 && index < definition.damage.components.length)
      && Number.isInteger(scaling.dicePerLevel) && scaling.dicePerLevel >= 0)));
};

export const damageForCastLevel = (definition, castLevel, characterLevel) => {
  const level = Number(castLevel);
  if (!definition || !Number.isInteger(level) || level < definition.level || level > 9) throw new Error('Invalid cast level.');
  const damage = { components: definition.damage.components.map((component) => ({ ...component })) };
  if (definition.level === 0) {
    if (level !== 0 || !Number.isInteger(characterLevel) || characterLevel < 1 || characterLevel > 20) throw new Error('Invalid cantrip character level.');
    const count = 1 + [5, 11, 17].filter((threshold) => characterLevel >= threshold).length;
    const base = parseSaveDamageDice(damage.components[0].formula);
    if (!base) throw new Error('Invalid cantrip damage definition.');
    damage.components[0].formula = `${base.count * count}d${base.sides}`;
  }
  if (definition.scaling?.mode === 'dice-per-slot-level') {
    for (const index of definition.scaling.components || [definition.scaling.component]) {
    const match = /^(\d+)d(\d+)$/.exec(damage.components[index]?.formula || '');
    if (!match) throw new Error('Invalid scalable damage definition.');
    damage.components[index].formula = `${Number(match[1]) + ((level - definition.level) * definition.scaling.dicePerLevel)}d${match[2]}`;
    }
  }
  return damage;
};

